/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { WageDto } from '../models/WageDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WagesService {
  /**
   * 현재 유저의 이력서 가져오기
   * @returns WageDto
   * @throws ApiError
   */
  public static wageControllerGetMyWage(): CancelablePromise<Array<WageDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/wages/me',
    });
  }
}
